import { Link } from 'react-router';
import equalHousingLogo from '../../assets/equal-housing-opportunity-logo.png';
import { BrandMark } from '../../components/BrandMark.js';

/**
 * Dark-green site-wide footer, per the reference screenshot. Genuinely new —
 * nothing else in the app has a footer to pattern-match (the closest thing,
 * `PoweredByFooter` in LoginPage.tsx, is a private, non-exported local).
 *
 * The four compliance links route to real pages (CompliancePage.tsx) with
 * placeholder content — "generate the pages, fill in the details later" is
 * this session's explicit scope, not a broken link.
 *
 * The reference mock shows two identical columns of the same four links —
 * read as a mock artifact, not a spec, so this renders one column.
 *
 * The Equal Housing logo below is a SEPARATE requirement from the
 * "Equal Housing Opportunity" nav link above it: CLAUDE.md's Public
 * listings site section requires the logo itself to render as chrome from
 * the layout on every page, "so it cannot be omitted by a data entry
 * mistake" — not just a footer link to a policy page. The official HUD
 * mark (assets/equal-housing-opportunity-logo.png), not a substitute —
 * wrapped in a white card since the source has a light background and
 * would lose contrast directly on this footer's dark green, same
 * technique `.public__footer-brand img` already uses for the brand logo.
 */
export function PublicFooter() {
  return (
    <footer className="public__footer">
      <div className="public__footer-brand">
        <BrandMark />
      </div>
      <nav className="public__footer-links" aria-label="Compliance and policies">
        <Link to="/compliance">Compliance</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-of-use">Terms of Use</Link>
        <Link to="/equal-housing">Equal Housing Opportunity</Link>
      </nav>
      <div className="public__eho-badge">
        <img src={equalHousingLogo} alt="Equal Housing Opportunity" />
      </div>
    </footer>
  );
}
